declare global {
	interface Window {
		opera: string;
		MSStream: string;
	}
}

const getMobileOperatingSystem = () => {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// Windows Phone must come first because its UA also contains "Android"
	if (/windows phone/i.test(userAgent)) {
		return 'Windows Phone';
	}

	if (/android/i.test(userAgent)) {
		return 'Android';
	}

	// iOS detection from: http://stackoverflow.com/a/9039885/177710
	if (
		(/iPad|iPhone|iPod/i.test(userAgent) ||
			(/Macintosh/.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1)) &&
		!window.MSStream
	) {
		return 'iOS';
	}
	return 'unknown';
};

const isDesktopDetection = () => getMobileOperatingSystem() === 'unknown';

export { isDesktopDetection };
export default getMobileOperatingSystem;
